import { Action } from '@ngrx/store';
import { IShipmentLocationResponse } from '@cemex-core/cmx-api/models/shipment-location/shipment-location-response';
import { IShipmentLocation } from '@cemex-core/cmx-api/models/shipment-location/shipment-location';
import { IPointOfDeliverySalesArea } from '@cemex-core/cmx-api/models/point-of-delivery-sales-areas/point-of-delivery-sales-area';
import {
    IAddressResponse,
    IRequestedAddressResponse,
  } from '@cemex-core/cmx-api/models/addresses-req-management/addresses-response';
import { ILocationConfigUnit } from '@ordersnproducts/modules/order-builder/modules/location/models/location-config.interface';
export const LOAD_INITIAL_STATE = '[Point of delivery] Load initial state';
export const LOAD = '[Point of delivery] Load';
export const LOAD_COMPLETE = '[Point of delivery] Load Complete';
export const LOAD_FAIL = '[Point of delivery] Load Fail';
export const REMOVE_SELECTED_POD = '[Point of delivery] Remove Selected';
export const POINT_OF_DELIVERY_SET = '[Point of delivery] Set';
export const LOAD_ADDRESS = '[Point of delivery] Load address';
export const LOAD_ADDRESS_SUCCESS = '[Point of delivery] Load address success';
export const LOAD_ADDRESS_FAIL = '[Point of delivery] Load address fail';
export const LOAD_SALES_AREA = '[Point of delivery] Load sales area';
export const LOAD_SALES_AREA_SUCCESS = '[Point of delivery] Load sales area success';
export const LOAD_SALES_AREA_FAIL = '[Point of delivery] Load sales area fail';
export const POD_SET_AVAILABILITY = '[Point of delivery] set availability';
export const TOGGLE_SHOWING_POD_REQUESTS = '[Point of delivery] toggle showing pod requests';
export const POINT_OF_DELIVERY_CREATE = '[Point of delivery] new point of delivery create';
export const POINT_OF_DELIVERY_CREATED_FAILURE = '[Point of delivery] fail new point of delivery fail';
export const POINT_OF_DELIVERY_CREATED_SUCCESS = '[Point of delivery] new point of delivery created';
export const RESET_NEW_POINT_OF_DELIVERY = '[Point of delivery] reset new point of delivery';
export const LOAD_NEW_ADDRESS_FAIL = '[Point of delivery] Load new address fail';
//
export const POINT_OF_DELIVERY_OPPORTUNITIES_CREATE = '[Point of delivery] Create';
export const POINT_OF_DELIVERY_OPPORTUNITIES_CREATE_SUCCESS = '[Point of delivery] Create success';
export const PONT_OF_DELIVERY_OPPORTUNITIES_CREATE_FAIL = '[Point of delivery] Create fail';

export  const RESET_SNAPSHOT = '[Point of delivery] Reset SnapShot';
export  const UPDATE_SNAPSHOT = '[Point of delivery] Update SnapShot';

export class PointOfDeliveryLoadInitialStateAction implements Action {
    readonly type = LOAD_INITIAL_STATE;

    constructor(public payload: ILocationConfigUnit) {}
  }

  export class PointOfDeliveryLoadingAction implements Action {
    readonly type = LOAD;

    constructor(public payload: IShipmentLocation) {}
  }

  export class PointOfDeliveryLoadCompleteAction implements Action {
    readonly type = LOAD_COMPLETE;

    constructor(public payload: IShipmentLocationResponse) {}
  }

  export class PointOfDeliveryLoadFailAction implements Action {
    readonly type = LOAD_FAIL;

    // todo:: type of error handling
    constructor(public payload: any) {}
  }

  export class PointOfDeliveryRemoveSelectedAction implements Action {
    readonly type = REMOVE_SELECTED_POD;

    constructor(public payload: null) {}
  }

  export class PointOfDeliverySetAction implements Action {
    readonly type = POINT_OF_DELIVERY_SET;

    constructor(public payload: any) {}
  }

  export class LoadPointOfDeliveryAddress {
    readonly type = LOAD_ADDRESS;

    constructor(public payload: any) {}
  }

  export class LoadPointOfDeliveryAddressComplete {
    readonly type = LOAD_ADDRESS_SUCCESS;

    constructor(public payload: IAddressResponse | IRequestedAddressResponse) {}
  }

  export class LoadPointOfDeliveryAddressFail {
    readonly type = LOAD_ADDRESS_FAIL;

    // todo:: type of error handling
    constructor(public payload: any) {}
  }
  export class LoadPointOfDeliveryNewAddressFail {
    readonly type = LOAD_NEW_ADDRESS_FAIL;

    // todo:: type of error handling
    constructor(public payload: any) {}
  }

  export class LoadPointOfDeliverySalesArea {
    readonly type = LOAD_SALES_AREA;

    constructor(public payload: IShipmentLocation) {}
  }

  export class LoadPointOfDeliverySalesAreaComplete {
    readonly type = LOAD_SALES_AREA_SUCCESS;

    constructor(public payload: IPointOfDeliverySalesArea[]) {}
  }

  export class LoadPointOfDeliverySalesAreaFail {
    readonly type = LOAD_SALES_AREA_FAIL;

    // todo:: type of error handling
    constructor(public payload: any) {}
  }

  export class PointOfDeliverySetAvailabilityAction {
    readonly type = POD_SET_AVAILABILITY;

    constructor(public payload: boolean) {}
  }

  export class PointOfDeliveryToggleShowingRequestsAction {
    readonly type = TOGGLE_SHOWING_POD_REQUESTS;

    constructor(public payload: boolean) {}
  }

  export class PointOfDeliveryCreateAction {
    readonly type = POINT_OF_DELIVERY_CREATE;

    constructor(public payload: any) {}
  }

  export class NewPointOfDeliveryFailAction {
    readonly type = POINT_OF_DELIVERY_CREATED_FAILURE;

    constructor(public payload: any) {}
  }

  export class PointOfDeliveryCreatedSuccessAction {
    readonly type = POINT_OF_DELIVERY_CREATED_SUCCESS;

    constructor(public payload: any) {}
  }

  export class ResetPointOfDeliveryAction {
    readonly type = RESET_NEW_POINT_OF_DELIVERY;

    constructor() {}
  }

  export class PointOfDeliveryOpportunitiesCreateAction implements Action {
    readonly type = POINT_OF_DELIVERY_OPPORTUNITIES_CREATE;

    constructor(public payload: any) {}
  }

  export class PointOfDeliveryOpportunitiesCreateSuccessAction implements Action {
    readonly type = POINT_OF_DELIVERY_OPPORTUNITIES_CREATE_SUCCESS;

    constructor(public payload: any) {}
  }

  export class PointOfDeliveryOpportunitiesCreateFailAction implements Action {
    readonly type = PONT_OF_DELIVERY_OPPORTUNITIES_CREATE_FAIL;

    constructor() {}
  }

  export  class  ResetSnapshotAction implements Action {
    readonly type = RESET_SNAPSHOT;

    constructor() {}
  }

  export  class  UpdateSnapshotAction implements Action {
    readonly type = UPDATE_SNAPSHOT;

    constructor() {}
  }

  /**
   * Export a type alias of all actions in this action group
   * so that reducers can easily compose action types
   */
  export type PointOfDeliveryActions =
    | PointOfDeliveryLoadInitialStateAction
    | PointOfDeliveryLoadingAction
    | PointOfDeliveryLoadCompleteAction
    | PointOfDeliveryLoadFailAction
    | PointOfDeliveryRemoveSelectedAction
    | PointOfDeliverySetAction
    | LoadPointOfDeliveryAddress
    | LoadPointOfDeliveryAddressComplete
    | LoadPointOfDeliveryAddressFail
    | LoadPointOfDeliverySalesArea
    | LoadPointOfDeliverySalesAreaComplete
    | LoadPointOfDeliverySalesAreaFail
    | PointOfDeliverySetAvailabilityAction
    | PointOfDeliveryToggleShowingRequestsAction
    | PointOfDeliveryCreateAction
    | NewPointOfDeliveryFailAction
    | PointOfDeliveryCreatedSuccessAction
    | ResetPointOfDeliveryAction
    | LoadPointOfDeliveryNewAddressFail
    | PointOfDeliveryOpportunitiesCreateAction
    | PointOfDeliveryOpportunitiesCreateSuccessAction
    | PointOfDeliveryOpportunitiesCreateFailAction
    | ResetSnapshotAction
    | UpdateSnapshotAction
    ;
